import { provideZoneChangeDetection } from "@angular/core";
import * as L from 'leaflet';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Make leaflet globally available for leaflet-routing-machine
(window as any).L = L;

// Import leaflet-routing-machine after L is available globally
import 'leaflet-routing-machine';

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  .catch(err => console.error(err));
